module.exports = __webpack_public_path__ + "static/media/maintenanceTasks.1464e7c5.svg";